namespace Areas.Workflows {
    "use strict";

    export function gotoWorkflows() {
        location.href = "/Workflows/List/Created";
    }

    export function reSendEmail() {
        const keyId: any = getKeyId();

        if (keyId != null) {
            const url = `/Workflows/Edit/ReSendEmail/${keyId}`;
            Areas.sendRequest(url, null, "GET");
        }
        else {
            DevExpress.ui.notify("Record to copy not selected.  Use List instead!", "warning", 2000);
        }
    }

    export function gotoCopyFromForm() {
        const keyId: any = getKeyId();

        if (keyId != null) {
            Areas.sendRequest(`/Workflows/Create/CopyWorkflow/${keyId}`, null, "GET");
        }
        else {
            DevExpress.ui.notify("Record not selected.  Use List instead!", "warning", 2000);
        }
    }

    export function gotoCreateFromForm() {
        const keyId: any = getKeyId();

        if (keyId != null) {
            location.href = `/Workflows/Create/CreateWorkflow/${keyId}`;
        }
        else {
            DevExpress.ui.notify("Record not selected.  Use List instead!", "warning", 2000);
        }
    }

    function getKeyId() : any {
        return Areas.getOptionFromForm("WorkflowsForm", "KeyId");
    }

}

